module.exports = __webpack_public_path__ + "static/media/ZW.d2304015.svg";